const WizardSubLabel = ({ children, className = '' }) => {
  return <div className={`comp-wizard-sub-label ${className}`}>{children}</div>;
};

export default WizardSubLabel;
